export const TPDIframeId = 'TPDirectIframe';
export const TAP_PAY_SDK_PATH = 'https://js.tappaysdk.com/tpdirect/v5.12.3';
